import { LuPrinter } from "react-icons/lu";
import { GoCopy } from "react-icons/go";
import { AiOutlineFileExcel } from "react-icons/ai";
import { BsFiletypePdf } from "react-icons/bs";
import { BsFiletypeCsv } from "react-icons/bs";
import { IoIosArrowDown } from "react-icons/io";
import { IoMdClose } from "react-icons/io";
import { FiTrash2, FiEdit3, FiEye, FiEdit2, FiEdit } from "react-icons/fi";
import { RxUpdate } from "react-icons/rx";
import { RiTimer2Fill } from "react-icons/ri";
import { CiCalendar } from "react-icons/ci";
import { FaRegUserCircle } from "react-icons/fa";
import { FiAtSign } from "react-icons/fi";
import { BiBuildings } from "react-icons/bi";
import { LiaPenSolid } from "react-icons/lia";
import { CiMoneyBill } from "react-icons/ci";
import { LiaMoneyBillSolid } from "react-icons/lia";
import { FaRegCheckCircle } from "react-icons/fa";
import { IoIosArrowUp } from "react-icons/io";
import { TbFileInvoice } from "react-icons/tb";
import { RiFileUserLine } from "react-icons/ri";
import { LuCalculator } from "react-icons/lu"
import { FcClock } from "react-icons/fc"
import { FaLocationDot } from "react-icons/fa6";
import { IoFingerPrint } from "react-icons/io5";
import { FaRegQuestionCircle } from "react-icons/fa";
import { IoCheckmarkCircle  } from "react-icons/io5";
import { IoIosAttach } from "react-icons/io";
import { IoMdArrowBack } from "react-icons/io";
import { FaEarthAmericas } from "react-icons/fa6";
import { BsCurrencyDollar } from "react-icons/bs";
import { HiOutlineSave } from "react-icons/hi";
import { FaPassport } from "react-icons/fa";
import { FaBusinessTime } from "react-icons/fa";
import { LiaCitySolid } from "react-icons/lia"
import { IoPeopleSharp } from "react-icons/io5";
import { FaRegFileImage } from "react-icons/fa6";
import { RiCharacterRecognitionFill } from "react-icons/ri";
import { RiNewspaperFill } from "react-icons/ri";
import { MdOutlineWorkOutline } from "react-icons/md";
import { SiLevelsdotfyi } from "react-icons/si";
import { GrUserWorker } from "react-icons/gr";
import { FaCodeBranch } from "react-icons/fa6";
import { MdOutlineWork } from "react-icons/md";
import { PiPhoneOutgoingBold } from "react-icons/pi";
import { FaAudioDescription } from "react-icons/fa";
import { RiTimeZoneLine } from "react-icons/ri";
import { FaRegAddressCard } from "react-icons/fa";
import { MdWorkHistory } from "react-icons/md";
import { IoMdPeople } from "react-icons/io";
import { MdAlternateEmail } from "react-icons/md";
import { PiDeviceTabletDuotone } from "react-icons/pi";
import { MdAbc } from "react-icons/md";
import { PiMoneyWavy } from "react-icons/pi";
import { VscSymbolConstant } from "react-icons/vsc";
import { GrStatusGood } from "react-icons/gr";
import { IoMdAdd } from "react-icons/io";
import { FaRegTrashAlt } from "react-icons/fa"
import { LiaUserLockSolid } from "react-icons/lia";
import { FaCheckCircle } from "react-icons/fa";
import { SlArrowDown } from "react-icons/sl";
import { SlArrowUp } from "react-icons/sl";
import { RiLockPasswordLine } from "react-icons/ri";
import { IoMdSettings } from "react-icons/io";
import { IoCubeOutline } from "react-icons/io5";
import { GoDatabase } from "react-icons/go";
import { GoServer } from "react-icons/go";
import { IoMdCheckmark } from "react-icons/io";
import { FaCheck } from "react-icons/fa6";
import { ImAttachment } from "react-icons/im";
import { MdDateRange } from "react-icons/md";
import { FaAddressCard } from "react-icons/fa6";
import { VscFolderActive } from "react-icons/vsc";
import { FaRegCommentDots } from "react-icons/fa";
import { MdOutlineTimeline } from "react-icons/md";
import { GoFileMedia } from "react-icons/go";
import { VscSymbolField } from "react-icons/vsc";
import { BsQrCodeScan } from "react-icons/bs";
import { CgWebsite } from "react-icons/cg";
import { RiUserLocationLine } from "react-icons/ri";
import { MdOutlinePaid } from "react-icons/md";
import { FaSortAmountUpAlt } from "react-icons/fa";
import { FcRules } from "react-icons/fc";
import { MdMergeType } from "react-icons/md";
import { GiDuration } from "react-icons/gi";
import { RxValue } from "react-icons/rx";
import { VscGitPullRequestGoToChanges } from "react-icons/vsc";
import { MdOutlineEditNote } from "react-icons/md";
import { TbBrandDaysCounter } from "react-icons/tb";
import { FcProcess } from "react-icons/fc";
import { BsGenderAmbiguous } from "react-icons/bs";
import { MdBloodtype } from "react-icons/md";
import { LuClock2 } from "react-icons/lu";
import { BiCommentDetail } from "react-icons/bi";
import { MdOutlineHomeRepairService } from "react-icons/md";
import { GrCheckmark } from "react-icons/gr";
import { HiMiniXMark } from "react-icons/hi2";
import { IoEyeOffOutline } from "react-icons/io5";

const icons = {
  print: LuPrinter,
  copy: GoCopy,
  execl: AiOutlineFileExcel,
  pdf: BsFiletypePdf,
  csv: BsFiletypeCsv,
  arrowDown: IoIosArrowDown,
  close: IoMdClose,
  eye: FiEye,
  timer: RiTimer2Fill,
  update: RxUpdate,
  calendar: CiCalendar,
  profile:FaRegUserCircle,
  pen:FiEdit ,
  at:FiAtSign,
  bulid:BiBuildings,
  money :CiMoneyBill,
  arrowUp:IoIosArrowUp,
 invoice :TbFileInvoice,
 user :RiFileUserLine,
 clock:FcClock,
 location:FaLocationDot,
 finger:IoFingerPrint,
 questionCircle:FaRegQuestionCircle,
 checkMark: IoCheckmarkCircle ,
 attach:IoIosAttach,
 back:IoMdArrowBack,
 permisson:LiaUserLockSolid,
 Dollar:BsCurrencyDollar,
 Save:HiOutlineSave,
 Earth:FaEarthAmericas,
 PassPort :FaPassport,
 City :LiaCitySolid,
 role:IoPeopleSharp,
 image:FaRegFileImage,
 name:RiCharacterRecognitionFill,
 request:RiNewspaperFill,
 company:MdOutlineWorkOutline,
 levels:SiLevelsdotfyi,
 Employment:GrUserWorker,
 Shifts :FaBusinessTime,
 branch:FaCodeBranch,
 company:MdOutlineWork,
 phone:PiPhoneOutgoingBold,
 description:FaAudioDescription,
 timeZone:RiTimeZoneLine,
 address:RiUserLocationLine,
 workShifts :MdWorkHistory,
employ:IoMdPeople ,
email:MdAlternateEmail,
device:PiDeviceTabletDuotone,
checkCircle :FaRegCheckCircle ,
abc:MdAbc ,
money :PiMoneyWavy,
constract:VscSymbolConstant,
status:GrStatusGood,
add:IoMdAdd ,
trash:FaRegTrashAlt,
task:FaCheckCircle,
ArrowDown :SlArrowDown,
ArrowUp :SlArrowUp,
password:RiLockPasswordLine,
settings:IoMdSettings,
cube:IoCubeOutline,
data:GoDatabase,
server:GoServer, 
checkMark:FaCheck,
attachment:ImAttachment,
date:MdDateRange,
idCard :FaAddressCard,
active:VscFolderActive,
comment:FaRegCommentDots,
timeline:MdOutlineTimeline,
file :GoFileMedia,
feild:VscSymbolField,
qr :BsQrCodeScan,
website:CgWebsite,
cal:LuCalculator,
paid :MdOutlinePaid,
amount:FaSortAmountUpAlt,
status :GrStatusGood,
rules:FcRules,
type:MdMergeType,
duration:GiDuration,
value:RxValue,
request:VscGitPullRequestGoToChanges,
note:MdOutlineEditNote,
days:TbBrandDaysCounter,
process:FcProcess,
gender:BsGenderAmbiguous,
blood:MdBloodtype ,
clock:LuClock2,
comment:BiCommentDetail,
service:MdOutlineHomeRepairService,
accept:FaCheck,
reject:HiMiniXMark,
eyeoff:IoEyeOffOutline
};
export default icons;
